import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MediaPlayer, Page, TickerPlayer } from '../../components';
import { Box } from '../../components/layout';
import { Button } from '../../components/widgets';
import { getPlaylistV2, getDetailPlaylist, getTickerSeries,  } from '../../selectors';
import { requestFullscreenHelper } from '../../utils/fullscreen';
import './styles.scss';
import { APP_ROOT } from "signoxe/constants/config";
import {fetchPlaylistDetail, fetchPlaylistRequest} from "signoxe/actions"
import { Loading } from "signoxe/components/widgets";

class PreviewPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      mediaIndex: 0,
      tickerIndex: 0,
    };

    this.nextTicker = this.nextTicker.bind(this);
  }

  static propTypes = {
    playlist: PropTypes.object,
    fetchPlaylistDetail:PropTypes.func.isRequired,
    ticker: PropTypes.object,
    match: PropTypes.object,
  };

  handleFullScreen = () => requestFullscreenHelper(this.page);

  nextMedia = () =>
    this.setState({
      mediaIndex: (this.state.mediaIndex + 1) % this.props.playlist.items.length,
    })

  nextTicker(currentIndex, allowNextTicker) {
    return () => {
      if (!allowNextTicker) {
        return;
      }
      const nextIndex = currentIndex + 1;
      this.setState({
        tickerIndex: nextIndex % this.props.ticker.tickers.length,
      })
    }
  }

  getMedia() {
    if (this.props.playlist && this.props.playlist.items && this.props.playlist.items.length > 0) {
      const item = this.props.playlist.items[this.state.mediaIndex].item;
      const duration = this.props.playlist.items[this.state.mediaIndex].duration;
      return {
        duration,
        ...item,
        asset_url: (item.asset_url && item.asset_url[0] === '/') ? (APP_ROOT + item.asset_url) : item.asset_url
      };
    }
  }

  getTicker() {
    if (this.props.ticker && this.props.ticker.tickers && this.props.ticker.tickers.length > 0) {
      return this.props.ticker.tickers[this.state.tickerIndex];
    } else {
      return null;
    }
  }


  componentDidMount() {
    this.props.fetchPlaylistDetail(this.props.match.params.playlistId);
  }


  render() {

    console.log("this.props.playlist", this.props.playlist)
    const media = this.getMedia();

    if (!this.props.playlist || !media) return <Loading/>;

    const ticker = this.getTicker();
    const { type, duration, asset_url } = media;
    console.log("🚀 ~ file: index.js ~ line 74 ~ PreviewPage ~ render ~ duration", duration)

    return (
      <Page className="preview-page">
        <Box direction="row" justifyContent="flex-end">
          <Button onClick={this.handleFullScreen}>View in Fullscreen</Button>
        </Box>
        <div className="media-container" ref={(page) => this.page = page} allowFullScreen>
          {type && <MediaPlayer type={type}
            duration={duration}
            url={asset_url}
            index={this.state.mediaIndex}
            onPlaybackDone={this.nextMedia} />}
          {ticker &&
            <TickerPlayer
              background={ticker.background}
              colour={ticker.colour}
              outline={ticker.outline}
              fontFamily={ticker.font_family}
              fontSize={ticker.font_size}
              speed={ticker.speed}
              text={ticker.text}
              isURL={ticker.is_url}
              index={this.state.tickerIndex}
              onTickerEnd={this.nextTicker} />}
        </div>
      </Page>
    );
  }

}

export default connect((state, { match }) => ({
  playlist: getDetailPlaylist(state),
  ticker: getTickerSeries(state, parseInt(match.params.tickerId, 10)),
}),
{
  fetchPlaylistDetail,
  fetchPlaylistRequest
}


)(PreviewPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/PreviewPage/index.js